
  // Generate or retrieve sessionId from localStorage
  let sessionId = localStorage.getItem('sessionId');
  if (!sessionId) {
    sessionId = 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    localStorage.setItem('sessionId', sessionId);
  }

  // Capture ad-attribution params on the LANDING hit and persist them (first-touch wins),
  // so checkout can stamp them onto the Shopify order for creative-level revenue attribution.
  try {
    var _p = new URLSearchParams(window.location.search);
    ['utm_content', 'utm_campaign', 'utm_source', 'alart', 'aleid', 'fbclid', 'gclid'].forEach(function (k) {
      var v = _p.get(k);
      if (v && !localStorage.getItem('attr_' + k)) { localStorage.setItem('attr_' + k, v); }
    });
  } catch (e) { /* no-op */ }

  // Stamp the first-touch attribution onto the Shopify CART (not a page), so the order carries
  // the creative even when the customer returns directly and buys on a non-funnel page. Cart
  // attributes are merged by key, so this never disturbs the buybox's funnel tag. Best-effort,
  // once per tab, only for ad-clicked visitors (attr_* present) and only on visible loads — so
  // organic traffic and Axon phantom background loads issue no request.
  try {
    if (document.visibilityState !== 'hidden' && !sessionStorage.getItem('attr_cart_stamped')) {
      var _attrs = {};
      ['utm_content', 'utm_campaign', 'utm_source', 'alart', 'aleid', 'fbclid', 'gclid'].forEach(function (k) {
        var v = localStorage.getItem('attr_' + k);
        if (v) { _attrs[k] = v; }
      });
      if (Object.keys(_attrs).length) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: _attrs })
        }).then(function () {
          try { sessionStorage.setItem('attr_cart_stamped', '1'); } catch (e) { /* no-op */ }
        }).catch(function () { /* non-blocking — never affects the page */ });
      }
    }
  } catch (e) { /* no-op */ }

  // Dynamically define sections based on initial scrollHeight
  function initializeSections() {
    const scrollHeight = document.documentElement.scrollHeight;
    return {
      hero: { start: 0, end: Math.floor(scrollHeight * 0.3) },    // Top 30%
      middle: { start: Math.floor(scrollHeight * 0.31), end: Math.floor(scrollHeight * 0.7) }, // Middle 40%
      bottom: { start: Math.floor(scrollHeight * 0.71), end: scrollHeight } // Bottom 30%
    };
  }

  let sections = initializeSections();
  let currentSection = null;
  let sectionStartTime = null;

  // Recalculate sections on scroll to handle dynamic content
  function updateSections() {
    const newSections = initializeSections();
    if (JSON.stringify(sections) !== JSON.stringify(newSections)) {
      console.log('Sections updated:', newSections);
      sections = newSections;
    }
  }

  function getScrollSection(scrollY) {
    updateSections(); // Update ranges before checking
    for (let section in sections) {
      if (scrollY >= sections[section].start && scrollY <= sections[section].end) {
        console.log(`ScrollY: ${scrollY}, Section: ${section}, Range: ${sections[section].start}-${sections[section].end}`);
        return section;
      }
    }
    console.warn(`ScrollY: ${scrollY} out of range, defaulting to 'bottom' (scrollHeight: ${document.documentElement.scrollHeight})`);
    return 'bottom'; // Fallback to 'bottom' for out-of-range scrolls
  }

  function sendSectionData(section, duration) {
    fetch('https://heatmap4dos-yf3zi.ondigitalocean.app/track', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        sessionId: sessionId,
        x: window.innerWidth / 2,
        y: window.scrollY,
        page: window.location.href,
        platform: window.location.host.includes('shopify') ? 'shopify' : 'clickfunnels',
        type: 'scroll',
        section: section,
        duration: duration
      }),
      keepalive: true
    }).catch(err => console.error('Tracking error:', err));
  }

  function trackScroll() {
    const scrollY = window.scrollY;
    const section = getScrollSection(scrollY);
    if (section !== currentSection) {
      if (currentSection && sectionStartTime) {
        const duration = (Date.now() - sectionStartTime) / 1000;
        sendSectionData(currentSection, duration);
      }
      currentSection = section;
      sectionStartTime = Date.now();
    }
  }

  // Click tracking
  function describeEl(el) {
    if (!el || !el.tagName) return null;
    var cls = typeof el.className === 'string' ? el.className : (el.getAttribute ? el.getAttribute('class') : '');
    return ((el.dataset && el.dataset.track) || el.id || cls || el.tagName.toLowerCase()).toString().slice(0, 80);
  }
  document.addEventListener('click', function(e) {
    // Prefer the nearest intentional/interactive ancestor; fall back to the raw element so target is never null
    var el = e.target.closest('[data-track], button, a, input, label, [role="radio"], [role="button"], .pricing-btn');
    var target = describeEl(el) || describeEl(e.target);
    fetch('https://heatmap4dos-yf3zi.ondigitalocean.app/track', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        sessionId: sessionId,
        x: e.clientX,
        y: e.clientY,
        page: window.location.href,
        platform: window.location.host.includes('shopify') ? 'shopify' : 'clickfunnels',
        type: 'click',
        target: target
      }),
      keepalive: true
    }).catch(err => console.error('Click tracking error:', err));
  });

  // Record initial page load — captures visitors who bounce without scrolling.
  // Axon end-card taps load the page in a BACKGROUND webview (document.hidden===true)
  // with no human present — these are phantom pageviews. Tag them so phantom share is
  // measurable, and only start the dwell timer once the page is actually visible.
  var loadedHidden = (document.visibilityState === 'hidden');
  currentSection = getScrollSection(window.scrollY);
  sectionStartTime = loadedHidden ? null : Date.now();
  fetch('https://heatmap4dos-yf3zi.ondigitalocean.app/track', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      sessionId: sessionId,
      x: window.innerWidth / 2,
      y: window.scrollY,
      page: window.location.href,
      platform: window.location.host.includes('shopify') ? 'shopify' : 'clickfunnels',
      type: 'pageview',
      section: currentSection,
      target: loadedHidden ? 'loaded-hidden' : 'loaded-visible',
      duration: 0
    }),
    keepalive: true
  }).catch(err => console.error('Pageview tracking error:', err));

  // Scroll tracking
  window.addEventListener('scroll', trackScroll);

  // Exit dwell: beforeunload rarely fires in mobile webviews (all in-game ad traffic),
  // so flush on visibilitychange/pagehide too. sectionStartTime=null guards double-sends;
  // timer restarts if the page becomes visible again (also excludes backgrounded time).
  function flushDwell() {
    if (currentSection && sectionStartTime) {
      const duration = (Date.now() - sectionStartTime) / 1000;
      sectionStartTime = null;
      sendSectionData(currentSection, duration);
    }
  }
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'hidden') {
      flushDwell();
    } else if (!sectionStartTime) {
      sectionStartTime = Date.now();
    }
  });
  window.addEventListener('pagehide', flushDwell);
  window.addEventListener('beforeunload', flushDwell);
